export const MOE_EVENTS = {
  STUDIO_CONVERT_SUCCESS: 'studio_convert_success',
  AUDIO_DOWNLOADED: 'audio_downloaded',
  PROJECT_EXPORTED: 'project_exported',
  PRONUNCIATION_CHECK_COMPLETED: 'pronunciation_check_completed',
  AUDIO_PLAYED: 'audio_played',
  STUDIO_PREVIEW_TTS: 'Studio_Preview_TTS',
  DOCUMENT_IMPORTED: 'document_imported',
  PROJECT_CREATED: 'project_created',
  // Fires on API accept, BEFORE the payment-gateway redirect — intent, not confirmed enablement
  AUTO_RENEW_CLICKED: 'auto_renew_clicked',
  AUTO_RENEW_CANCELLED: 'auto_renew_cancelled',
  ONBOARDING_TASK_COMPLETED: 'onboarding_task_completed',
  ACTIVE_FREE_PLAN: 'Active_FreePlan',
  EDUCATORS_HOME_VIEWED: 'educators_home_viewed',
  EDUCATORS_FEATURE_CLICKED: 'educators_feature_clicked',
  EDUCATORS_VOICE_PREVIEWED: 'educators_voice_previewed',
  PAYWALL_HIT: 'paywall_hit',
  PAYWALL_CTA_CLICKED: 'paywall_cta_clicked',
  PROJECT_FILTER_APPLIED: 'project_filter_applied',
};

// Block filters in the project editor toolbar
export const MOE_FILTER_TYPE = {
  STATUS: 'status',
  VOICE: 'voice',
  SPEAKER: 'speaker',
};

// Which gate blocked the user — mirrors the dialog that opened
export const MOE_PAYWALL_TYPE = {
  OUT_OF_CREDITS: 'out_of_credits',
  // Paid actions priced up-front (translate, rewrite, video export)
  NOT_ENOUGH_CREDITS: 'not_enough_credits',
  MAX_CHARS: 'max_chars',
  EXPIRED_PACKAGE: 'expired_package',
  NO_PACKAGE: 'no_package',
  LOCKED_CREDITS: 'locked_credits',
  LOCKED_VOICE: 'locked_voice',
  // Generic LimitedFeaturesDialog — the dialog does not know which feature opened it
  LOCKED_FEATURE: 'locked_feature',
  VOICE_TRIAL_LIMIT: 'voice_trial_limit',
  MAX_SPEAKERS: 'max_speakers',
  PREMIUM_AI: 'premium_ai',
};

// What the user was doing when the gate fired
export const MOE_PAYWALL_TRIGGER = {
  CONVERT: 'convert',
  PREVIEW: 'preview',
  SAVE: 'save',
  // Client check passed but the API rejected the request
  SERVER_ERROR: 'server_error',
};

// Which wallet the locked_credits gate tripped on
export const MOE_LOCKED_WALLET = {
  CYCLE: 'cycle',
  TOPUP: 'topup',
};

export const MOE_PAYWALL_CTA = {
  UPGRADE: 'upgrade',
  TOPUP: 'topup',
};

// feature_key: UI key for locked_voice / locked_feature, package feature code for premium_ai
export const MOE_FEATURE_KEY = {
  PRONUNCIATION_CHECK: 'aiEditorPronunciationCheck',
};

export const MOE_MODULE = {
  TTS: 'tts',
  API: 'api',
  SRT: 'srt',
  PROJECT: 'project',
};

export const MOE_SURFACE = {
  REQUEST_LIST: 'request_list',
  TITLE_BAR: 'title_bar',
  PLAYER: 'player',
  BULK: 'bulk',
  PROJECT_EDITOR: 'project_editor',
  PROJECT_BLOCK: 'project_block',
  // Project-creation popups, before a project exists
  PROJECT_CREATE: 'project_create',
};

export const MOE_DOCUMENT_TYPE = {
  DOCX: 'docx',
  TXT: 'txt',
  PDF: 'pdf',
  PDF_SCANNED: 'pdf_scanned',
  URL: 'url',
};

export const MOE_PROJECT_SOURCE_TYPE = {
  EMPTY_TEXT: 'empty_text',
  FILE_DOC: 'file_doc',
  FILE_PDF: 'file_pdf',
  FILE_TXT: 'file_txt',
  FILE_SRT: 'file_srt',
  FILE_PPTX: 'file_pptx',
  FILE_AUDIO: 'file_audio',
  FILE_VIDEO: 'file_video',
  URL: 'url',
  SAMPLE: 'sample',
};

export const MOE_CLONE_TYPE_PROFESSIONAL = 'professional';

export const MOE_AUTO_RENEW_ACTION = {
  REGISTER: 'register',
  RESUME: 'resume',
};

export const MOE_CONFIG = {
  SDK_POLL_INTERVAL_MS: 200,
  SDK_WAIT_TIMEOUT_MS: 10000,
  FIRST_FLAG_PREFIX: 'MOE_FIRST_',
  // Read by survey popup templates (MoEngage iframe) as user_id fallback
  UID_STORAGE_KEY: 'MOE_UID',
  // Read by survey popup templates as environment tag (prod/uat/dev...)
  ENV_STORAGE_KEY: 'MOE_ENV',
  // LOCKED — changing the salt reshuffles every user's survey bucket
  SURVEY_BUCKET_SALT: ':survey',
  SURVEY_BUCKET_SIZE: 100,
  // Cross-tab dedupe for events every open tab observes (WS broadcast, resumed polling)
  TRACKED_IDS_STORAGE_KEY: 'MOE_TRACKED_IDS',
  TRACKED_IDS_MAX: 100,
};
